import { defineComponent, onMounted, ref, watch } from "vue";
import { VueBrowseClasses } from "./../../classes";
import InfiniteScrollContainer from "./infiniteScrollContainer";
import { browseStore } from "../../store";

export default /*#__PURE__*/ defineComponent(
    {
        name: "scrollContainer",
        setup(_, { slots })
        {
            const state = browseStore.injectBrowseState();
            if (!state)
            {
                throw new Error("Unable to retrieve browse state");
            }

            const scrollContainer = ref();

            onMounted(() =>
            {
                watch(() => state.data, () => scrollContainer.value.scrollTop = 0);
            });


            const classes =
            {
                [VueBrowseClasses.UnlockedBody]: true
            };

            if (state.features.pagingType.typeIdentifier === "InfiniteScroll")
            {
                return () => (
                    <InfiniteScrollContainer
                        ref={scrollContainer}
                        class={{ ...classes }}>
                        {slots.default?.()}
                    </InfiniteScrollContainer>
                );
            }
            else
            {
                return () => (<div ref={scrollContainer} class={{ ...classes }}>{slots.default?.()}</div>);
            }
        }
    }
);